<button
  class="go-icon-button"
  [ngClass]="{ 'go-icon-button--disabled': buttonDisabled }"
  (click)="clicked()"
  [disabled]="buttonDisabled"
  [attr.title]="buttonTitle"
  type="button"
>
  <go-icon
    [icon]="buttonIcon"
    [iconClass]="iconClass"
    class="go-icon-button__icon"
  ></go-icon>
</button>
